// The room name of the faction club (casino.md §16.1, R2165).
//
// The casino is the room of the club faction, and the charge on the badge
// of that faction names the room. Two surfaces name it: the club head of
// the casino (`ui/casino/club.ts`) and the CLUB SHARE message of the INBOX
// (`ui/inbox/words.ts`, R2144). The rule lives here, outside `ui/casino/`,
// and `client/vite.config.mts` puts it in the `casino` build chunk group
// all the same: the club head imports it from that chunk, and the INBOX
// reaches it from the main chunk, the one direction the two chunks may
// take (R1432).

import { overlay as S } from '../gen/strings';
import { factionName, factionOf } from '../world';

/** The room name of each charge of `data/identity/identity.toml`, in the
 *  reader's language, built once at load (R855). */
const ROOMS: Readonly<Record<string, string>> = {
  waves: S.casino_room_waves,
  gears: S.casino_room_gears,
  bezants: S.casino_room_bezants,
  frond: S.casino_room_frond,
  chevronels: S.casino_room_chevronels,
};

/** The room name of the club faction: the charge of its badge names it.
 *  A charge with no word of its own takes the faction's name. */
export function roomName(faction: number): string {
  const f = factionOf(faction);
  if (!f) return '';
  return ROOMS[f.charge] ?? S.casino_room_other({ faction: factionName(faction) });
}
